import { ChevronDown, Phone, Sparkles, BedDouble, UtensilsCrossed } from "lucide-react";
import { IMAGES, PHONE, PHONE_TEL } from "../data";

const HIGHLIGHTS = [
  { icon: Sparkles, title: "Marriage Hall", text: "Elegant celebrations & events", testid: "hero-highlight-marriage-hall" },
  { icon: BedDouble, title: "Hotel Rooms", text: "Comfortable stays", testid: "hero-highlight-rooms" },
  { icon: UtensilsCrossed, title: "Restaurant", text: "Delicious dining experience", testid: "hero-highlight-restaurant" },
];

export const Hero = () => (
  <section id="home" data-testid="hero-section" className="relative flex min-h-screen items-center overflow-hidden bg-navy">
    <img
      src={IMAGES.hero}
      alt="Grand marriage hall at Kasdol Hotel decorated for a wedding celebration"
      className="absolute inset-0 h-full w-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-b from-navy/85 via-navy/60 to-navy" aria-hidden="true" />

    <div className="section-wrap relative z-10 pb-44 pt-32 text-center sm:pb-40">
      <p data-testid="hero-eyebrow" className="hero-anim eyebrow" style={{ animationDelay: "100ms" }}>
        Welcome to Kasdol Hotel
      </p>
      <h1
        data-testid="hero-heading"
        className="hero-anim mx-auto mt-5 max-w-4xl font-serif text-4xl font-bold leading-tight text-cream sm:text-5xl lg:text-6xl"
        style={{ animationDelay: "250ms" }}
      >
        Where Celebrations Meet Comfort
      </h1>
      <p
        data-testid="hero-subheading"
        className="hero-anim mx-auto mt-5 max-w-2xl text-base text-cream/80 sm:text-lg"
        style={{ animationDelay: "400ms" }}
      >
        A complete hospitality destination for memorable celebrations, comfortable stays and delightful dining.
      </p>

      <div
        className="hero-anim mt-9 flex flex-col items-center justify-center gap-4 sm:flex-row"
        style={{ animationDelay: "550ms" }}
      >
        <a href="#services" data-testid="hero-cta-explore" className="btn-gold w-full sm:w-auto">
          Explore Our Services
        </a>
        <a href={PHONE_TEL} data-testid="hero-cta-call" className="btn-outline w-full sm:w-auto">
          <Phone className="h-4 w-4" /> Call {PHONE}
        </a>
      </div>

      <div
        data-testid="hero-service-highlights"
        className="hero-anim mx-auto mt-14 grid max-w-4xl gap-4 sm:grid-cols-3"
        style={{ animationDelay: "700ms" }}
      >
        {HIGHLIGHTS.map((h) => (
          <div
            key={h.title}
            data-testid={h.testid}
            className="rounded-md border border-gold/25 bg-navy/50 p-5 text-left backdrop-blur-md sm:text-center"
          >
            <h.icon className="h-6 w-6 text-gold sm:mx-auto" />
            <h2 className="mt-3 font-serif text-lg font-semibold text-cream">{h.title}</h2>
            <p className="mt-1 text-sm text-cream/70">{h.text}</p>
          </div>
        ))}
      </div>
    </div>

    <a
      href="#services"
      data-testid="hero-scroll-indicator"
      aria-label="Scroll down to explore services"
      className="absolute bottom-24 left-1/2 z-10 -translate-x-1/2 text-gold transition-colors hover:text-cream md:bottom-10"
    >
      <ChevronDown className="scroll-dot h-8 w-8" />
    </a>
  </section>
);
